export default {
  'Resize for': 'आकार बदलें',
  'Add 10 videos at most': 'अधिकतम 10 वीडियो डालें।',
}